export default __webpack_public_path__ + "static/media/shina.e80566cb.jpg";